/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import { useToast } from '@ecsper/ui-primitives';
import { useEffect } from 'react';

/** Listens for ribbon Stage 6 stub `postMessage` events and surfaces them as toasts. */
export function Stage6ToastBridge(): null {
  const { toast } = useToast();
  useEffect(() => {
    const onMessage = (e: MessageEvent): void => {
      if (e.origin !== window.location.origin) {
        return;
      }
      if (e.data?.type === 'ecsper:stage6-stub' && typeof e.data.label === 'string') {
        toast(`${e.data.label} (Available in Stage 6)`, 'info');
      }
    };
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [toast]);
  return null;
}
